import { array, boolean, defineAction, object, string } from '~/prix'
import insightSendEmailAction from './insightSendEmail.action.json'

const insightSendEmailDefinition = defineAction({
  ...insightSendEmailAction,
  input: object({}),
  output: object({
    warnings: array(
      object({
        message: string(),
      }),
    ),
    success: object({
      success: boolean(),
      id: string().isOptional(),
    }),
  }),
})

export default insightSendEmailDefinition
